module.exports = __webpack_public_path__ + "img/N115-2.2e511f12.png";